/**
 * @desc 通过Redis获取审批人
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.test.getApprover.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/getApprover`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
